const INITIAL_STATE = {
  items: {},
};

module.exports = function TradingCampaignBalanceReducer(
  state = INITIAL_STATE,
  action,
) {
  switch (action.type) {
    case 'FETCH_CAMPAIGN_BALANCE_SUCCESSFUL': {
      return {
        ...state,
        items: {
          ...state.items,
          [action.campaignId]: {
            balance: action.balance,
            fetchingInProgressSince: null,
            didInvalidate: false,
            lastSuccessfulFetch: action.timestamp,
          },
        },
      };
    }
    case 'FETCH_CAMPAIGN_BALANCE_IN_PROGRESS': {
      return {
        ...state,
        items: {
          ...state.items,
          [action.campaignId]: {
            ...(state.items[action.campaignId] || {}),
            fetchingInProgressSince: action.timestamp,
          },
        },
      };
    }
    case 'FETCH_CAMPAIGN_BALANCE_FAILED': {
      return {
        ...state,
        items: {
          ...state.items,
          [action.campaignId]: {
            ...(state.items[action.campaignId] || {}),
            fetchingInProgressSince: null,
            lastFailedFetch: action.timestamp,
          },
        },
      };
    }
    case 'LOGOUT_SUCCESSFUL': {
      return {
        ...state,
        items: {},
      };
    }
    default:
      return state;
  }
};
